<template>
    <button type="button" class="btn-reset" @click="click">
        <span class="sr-only">{{ srText }}</span>
        <span :class="iconClasses"></span>
    </button>
</template>

<script>
    import axios from 'axios';

    export default {
        props: {
            removeText: {
                type: String,
                default: `Remove from favorites`
            },
            addText: {
                type: String,
                default: `Add to favorites`
            },
            activeClass: {
                type: String,
                default: 'icon-solid-heart h-color--red'
            },
            inactiveClass: {
                type: String,
                default: 'icon-heart h-color--black'
            },
            endpoint: {
                type: String,
                default: '/aha-service/RecipeBox/DeleteRecipe'
            },
            recipeId: {
                type: String,
                required: true
            },
            folderName: {
                type: String,
                required: true
            },
            savedDate: {
                type: String,
                required: true
            },
            errorMessage: {
                type: String,
                default: 'Error loading Recipe Box Folder'
            },
            name: {
                type: String,
                required: true
            },
            modalId: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                isFavorite: true,
                isProcessing: false,
                recipeBoxForm: null
            };
        },
        computed: {
            getName() {
                return this.$props.name;
            },
            srText() {
                return this.isFavorite ? this.$props.removeText : this.$props.addText;
            },
            iconClasses () {
                return [this.isFavorite ? this.$props.activeClass : this.$props.inactiveClass];
            }
        },
        methods: {
            click(evt) {
                evt.preventDefault();

                if(!this.isProcessing) {
                    // If it's currently a favorite, call the delete endpoint
                    if(this.isFavorite) {
                        axios({
                            method: 'post',
                            url: this.$props.endpoint, 
                            responseType: 'text',
                            data: {
                                recipeId: this.$props.recipeId,
                                folderName: this.$props.folderName,
                                savedDate: this.$props.savedDate
                            }
                        })
                        .then(response => {
                            if(response.data) {
                                this.isFavorite = !this.isFavorite;
                            }
                        }).catch((error) => {
                            // eslint-disable-next-line
                            console.log(error);
                        });
                    } else {
                        // Show the add to folder modal
                        this.$root.$emit('bv::show::modal', this.$props.modalId, evt.target);
                    }
                }

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/components/aha-recipe-box-favorite.vue